module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Welcoming services ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Free vererinary advices")]), _vm._v(" "), _c('p', [_vm._v("We listen to you")]), _vm._v(" "), _c('p', [_vm._v("We provide you a personnalised global solution")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Sale")]), _vm._v(" "), _c('p', [_vm._v("We only provide you studied and tested high quality products")]), _vm._v(" "), _c('p', [_vm._v("We guarantee on all products the lowest price on the market")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebca51cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/En/ServicesHome.vue
// module id = 153
// module chunks = 0